'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getBrowserDataFromUA = undefined;

var _uaParserJs = require('ua-parser-js');

var _uaParserJs2 = _interopRequireDefault(_uaParserJs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getMinimumBrowserVersions = function getMinimumBrowserVersions() {
    return {
        chrome: 45,
        edge: 13,
        firefox: 41,
        ie: 11,
        safari: 9
    };
};

var getBrowserDataFromUA = exports.getBrowserDataFromUA = function getBrowserDataFromUA(userAgentString) {
    var parser = new _uaParserJs2.default();

    parser.setUA(userAgentString);
    var result = parser.getResult();

    var name = '';
    var os = '';
    var majorVersion = 0;
    var mobile = '';
    var deviceType = '';

    if (result && result.browser) {
        if (typeof result.browser.name === 'string') {
            // Googlebot don't have a name
            name = result.browser.name.toLowerCase();
        }
        if (result.browser.major) {
            majorVersion = parseInt(result.browser.major, 10);
        }
    }
    if (result && result.os) {
        if (typeof result.os.name === 'string') {
            os = result.os.name.toLowerCase();
        }
    }
    if (result && result.device) {
        deviceType = result.device.type || ''; // [console, mobile, tablet, smarttv, wearable, embedded]

        if (result.device.type === 'mobile') {
            mobile = 'phone';
        } else if (result.device.type === 'tablet') {
            mobile = result.device.type;
        }
    }

    var minimumBrowserVersions = getMinimumBrowserVersions();

    var isOutdated = false;
    if (Object.prototype.hasOwnProperty.call(minimumBrowserVersions, name)) {
        isOutdated = minimumBrowserVersions[name] > majorVersion;
    }

    var isGoogle = userAgentString.toLowerCase().includes('google');
    if (isGoogle) {
        isOutdated = false;
    }

    return {
        deviceType: deviceType,
        isOutdated: isOutdated,
        majorVersion: majorVersion,
        microsoftBrowser: name === 'ie' || name === 'edge',
        mobile: mobile,
        name: name,
        os: os
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/utils/getBrowserDataFromUA.js
// module id = COnH
// module chunks = 57